export const useBrowser = () => {
	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	const isEdge = window.navigator.userAgent.indexOf('Edge') !== -1;
	const isIE = window.navigator.userAgent.indexOf('Trident') !== -1 && !isEdge;

	return {
		isSafari,
		isEdge,
		isIE,
	};
};
